export enum CertificationLevel {
  ALL = "All",
  LOW = "Low",
  MEDIUM = "Medium",
  HIGH = "High",
}
